import { FC, useState } from "react";
import { Heading } from "../../atoms/basics/heading";
import { HeaderOptions } from "../../../types/headerOptions";
import { Paragraph } from "../../atoms/basics/paragraph";
import { Form, Formik, FormikHelpers } from "formik";
import { TextField } from "../../molecules/fields/textField";
import { FieldButton } from "../../atoms/fieldButton";
import { SubscriptionChangeFormValidator } from "../../../validators/subscriptionChangeFormValidator";

interface ChangeSubscriptionFormProps {
  handleSubmit: (email: string) => Promise<void>;
}

export const ChangeSubscriptionForm: FC<ChangeSubscriptionFormProps> = ({handleSubmit}) => {
  const [emailSent, setEmailSent] = useState<boolean>(false);

  return (
    <div className="mx-auto md:text-center md:py-16 max-w-[650px] pr-24 md:pr-0">
      <h1 className="font-bold  text-24 sm:text-3xl text-black mb-1 mt-3 inline-flex items-center gap-2">
        Abonnement aanpassen/opzeggen
      </h1>
      <Paragraph>
        Vul hier uw e-mailadres in, wij versturen je een mail met een unieke
        link zodat jij je eigen abonnement zelf kan aanpassen.
      </Paragraph>
      {emailSent ? (
        <>
          <h3 className="font-bold text-24 text-green mt-16 mb-6">
            Email verzonden!
          </h3>
          <Paragraph color={"black"}>
            Als dit e-mailadres is gekoppeld aan een abonnement, ontvangt u
            binnen 5 minuten een email met een unieke link om uw abonnement aan
            te passen.
          </Paragraph>
        </>
      ) : (
        <Formik
          initialValues={{
            email: "",
          }}
          onSubmit={async (values, { setSubmitting }) => {
            setSubmitting(true);
            await handleSubmit(values.email)
            setEmailSent(true);
          }}
          validationSchema={SubscriptionChangeFormValidator}
        >
          {({}) => {
            return (
              <Form className="mt-16 md:flex md:justify-center">
                <div className="md:w-[350px]">
                  <TextField
                    name={"email"}
                    type={"text"}
                    label={""}
                    placeholder={"Naam@voorbeeld.nl"}
                  />
                </div>
                <FieldButton type="submit">Verstuur link</FieldButton>
              </Form>
            );
          }}
        </Formik>
      )}
    </div>
  );
};
